var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedManagent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bed-managent",
    transform: "translate(-435 -281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-management-icon",
    transform: "translate(-406.429 -1.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bed-management-icon-2",
    "data-name": "bed-management-icon",
    width: 28,
    height: 28,
    rx: 10,
    transform: "translate(852.429 282.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M5.986,0h4.276a6.241,6.241,0,0,1,5.986,6.468V9.24a6.241,6.241,0,0,1-5.986,6.468H5.986A6.241,6.241,0,0,1,0,9.24V6.468A6.241,6.241,0,0,1,5.986,0Z",
    transform: "translate(858.429 288.575)",
    fill: "#26ac6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    transform: "translate(864.429 305.429)",
    fill: "#24a56a",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(862.429 284.429)",
    fill: "#28b073"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    "data-name": "Ellipse 271",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(865.429 284.429)",
    fill: "#28b073"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(868.429 284.429)",
    fill: "#28b073"
  })), /*#__PURE__*/React.createElement("text", {
    id: "occupied",
    transform: "translate(436 321)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 12,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.007em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "occupied")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedManagent);
export default __webpack_public_path__ + "static/media/bed-managent.275faf6faecde8a1a7c4cd4631a7f152.svg";
export { ForwardRef as ReactComponent };